import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_BASE_URL || `${process.env.FRONTEND_URL}/api`;

export default function AgentProtectedRoute({ children }) {
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setStatus('invalid');
      return;
    }
    fetch(`${API_BASE}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json())
      .then((json) => {
        if (json.success && json.data.role === 'AGENT') {
          setStatus('valid');
        } else {
          localStorage.removeItem('token');
          setStatus('invalid');
        }
      })
      .catch(() => setStatus('invalid'));
  }, []);

  if (status === 'checking') return <p className="text-center py-40 text-[#64748b]">Verifying access...</p>;
  if (status === 'invalid') return <Navigate to="/login" replace />;
  return children;
}
